import { render, staticRenderFns } from "./editBranch.vue?vue&type=template&id=b8c5276c&"
import script from "./editBranch.vue?vue&type=script&setup=true&lang=js&"
export * from "./editBranch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports